// Add CSS for wishlist button styling
const style = document.createElement('style');
style.textContent = `
  .wishlist-btn {
    background: none;
    border: none;
    cursor: pointer;
    font-size: 24px;
    padding: 8px;
    transition: all 0.3s ease;
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .wishlist-btn svg {
    width: 24px;
    height: 24px;
    fill: none;
    stroke: #202440;
    stroke-width: 2;
    transition: all 0.3s ease;
  }

  .wishlist-btn.active svg {
    fill: #202440;
    stroke: #202440;
  }

  .wishlist-btn:hover {
    transform: scale(1.1);
  }

  .wishlist-btn:active {
    transform: scale(0.95);
  }

  /* Toast notification styles */
  .wishlist-toast {
    position: fixed;
    bottom: 20px;
    right: 20px;
    background: white;
    color: #202440;
    padding: 16px 24px;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    display: flex;
    align-items: center;
    gap: 12px;
    z-index: 9999;
    animation: slideIn 0.3s ease;
    border: 2px solid #202440;
  }

  @keyframes slideIn {
    from {
      transform: translateX(400px);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }

  .wishlist-toast.removing {
    animation: slideOut 0.3s ease;
  }

  @keyframes slideOut {
    from {
      transform: translateX(0);
      opacity: 1;
    }
    to {
      transform: translateX(400px);
      opacity: 0;
    }
  }
`;
document.head.appendChild(style);

// Heart SVG icon
const heartSVG = `
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
  </svg>
`;

// Show toast notification
function showToast(message) {
  // Remove existing toast if any
  const existingToast = document.querySelector('.wishlist-toast');
  if (existingToast) {
    existingToast.remove();
  }

  const toast = document.createElement('div');
  toast.className = 'wishlist-toast';
  toast.innerHTML = `<a href="https://mioraa.com/pages/wishlist">
    <svg viewBox="0 0 24 24" width="20" height="20" fill="#202440">
      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
    </svg>
    <span>${message}</span></a>
  `;
  document.body.appendChild(toast);

  setTimeout(() => {
    toast.classList.add('removing');
    setTimeout(() => toast.remove(), 300);
  }, 3000);
}

// Handle wishlist button clicks
document.addEventListener('click', function (e) {
  const btn = e.target.closest('.wishlist-btn');
  if (!btn) return;

  e.preventDefault();
  e.stopPropagation();

  let wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];
  const handle = btn.dataset.productHandle;

  if (!handle) return;

  if (wishlist.includes(handle)) {
    // Remove from wishlist
    wishlist = wishlist.filter(item => item !== handle);
    btn.classList.remove('active');
    showToast('Removed from wishlist');
  } else {
    // Add to wishlist
    wishlist.push(handle);
    btn.classList.add('active');
    showToast('Added to wishlist ❤️');
  }

  localStorage.setItem('wishlist', JSON.stringify(wishlist));

  // Dispatch custom event for other parts of the page to listen to
  window.dispatchEvent(new CustomEvent('wishlistUpdated', { 
    detail: { handle, action: wishlist.includes(handle) ? 'add' : 'remove' } 
  }));
});

// Initialize wishlist buttons on page load
document.addEventListener('DOMContentLoaded', () => {
  const wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];

  document.querySelectorAll('.wishlist-btn').forEach(btn => {
    // Replace content with heart SVG
    btn.innerHTML = heartSVG;
    
    // Add active class if item is in wishlist
    if (wishlist.includes(btn.dataset.productHandle)) {
      btn.classList.add('active');
    }
  });
});